import React from 'react';
import './ConfirmDialog.css'; // optional styling file

const ConfirmDialog = ({ show, title, text, onConfirm, onCancel }) => {
  if (!show) return null;
  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.6)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="close" onClick={onCancel}>
              <span>✕</span>
            </button>
          </div>
          <div className="modal-body">
            <p>{text}</p>
          </div>
          <div className="modal-footer" style={{ justifyContent: 'flex-end' }}>
            <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
            <button className="btn btn-primary" onClick={onConfirm} style={{ marginLeft: '8px' }}>Confirm</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
